// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "recommendations-1MBGP";
var _3 = "cancel-4Xo-X";
var _4 = "confirm-kM6C2";
export { _1 as "__esModule", _2 as "recommendations", _3 as "cancel", _4 as "confirm" }
export default { "__esModule": _1, "recommendations": _2, "cancel": _3, "confirm": _4 }
